<template>
	<div class="cont">
		<div class="top-title" @click="goDataCenter">重庆火锅产业大脑</div>
		<div v-if="$route.name === 'HomeView'" class="bottom-menu flex alit justc">
			<div class="flexCol alit" v-for="(m, i) in menuList" :key="m.name"
				:style="m.gap ? { margin: m.gap } : null" @click="onMenuClick(i)">
				<img class="menu-image" :src="menuIndex == m.index ? (m.activeIcon || m.icon) : m.icon" alt="" />
				<div :class="menuIndex == m.index ? 'menu-title' : 'menu-title-noCheck'">{{ m.name }}</div>
			</div>
		</div>
		<div class="topinfo flex justb">
			<!-- <div class="flex" v-if="showSanxia == 2">
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/home/image%402x.png"
					style="width: 36px;height: 20px;margin-left: 20px;" alt="" />
				<div class="szsn">重庆数字三农</div>
			</div>
			<img v-if="showSanxia == 1" style="height: 50px;;margin-left: 20px;margin-top: -20px;" 
          src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/%E4%B8%AD%E5%9B%BD%E4%B8%89%E5%B3%A12.png" alt="" /> -->
			
			<div class="topinfo-main flex justb">
				<div class="flex alit">
					<div class="flex alit">
						<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E8%BF%94%E5%9B%9E%402x%20%281%29.png"
							style="width: 18px;height: 18px;margin-top: -5px;margin-left: 10px;cursor: pointer;" alt=""
							@click="back" />
						<!--<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/home/%E5%AE%B9%E5%99%A8%402x%281%29.png"
							style="width: 36px;height: 36px;margin-left: 5px;" alt="" />
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/home/%E5%AE%B9%E5%99%A8%402x%282%29.png"
							style="width: 36px;height: 36px;margin-left: 0;" alt="" />
						<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/home/%E5%AE%B9%E5%99%A8%402x%283%29.png"
							style="width: 36px;height: 36px;margin: 0 10px 0 0;" alt="" />-->
					</div>
					<div :class="tabbarIndex == 1 ? 'tabbar-check' : 'tabbar-default'" @click="goDataCenter">数据中心</div>
	               <div :class="tabbarIndex == 7 ? 'tabbar-check' : 'tabbar-default'" style="margin-left: 10px;"
						@click="goIndustryWarehouse">行业数据仓</div>
					<div :class="tabbarIndex == 2 ? 'tabbar-check' : 'tabbar-default'" style="margin-left: 10px;"
						@click="goAbilityCenter">能力中心</div>
	             
				</div>
				<div class="flex">
					<div :class="tabbarIndex == 3 ? 'tabbar-check2' : 'tabbar-default2'" @click="goNationalMap">产业一张图
					</div>
					<!--<div :class="tabbarIndex == 4 ? 'tabbar-check2' : 'tabbar-default2'" style="margin-left: 10px;"
						@click="tabbarIndex = 4,goOld()">重庆火锅</div>-->
					
					<div :class="tabbarIndex == 6 ? 'tabbar-check2' : 'tabbar-default2'" style="margin-left: 10px;"
						@click="goIndustryChainV2">产业链图谱</div>
	               <div :class="tabbarIndex == 5 ? 'tabbar-check2' : 'tabbar-default2'" style="margin-left: 10px;"
						@click="goCenterAdmin">火锅业务中台</div> 
				</div>
			</div>
          <div v-if="$route.name === 'ComponentOverview'" class="back-ability-row">
				<div class="back-ability" @click="goAbilityCenter">‹ 返回能力中心</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import router from '@/router';

	export default {
		data() {
			return {
				menuIndex: 1,
				tabbarIndex: 1,
				// 底部菜单配置：activeIcon 为选中态图标预留位，后续替换；内跳项用 toRoute，外跳项用 url
				menuList: [{
					index: 1,
					name: '食材产地端',
					icon: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%BA%95%E9%83%A8%E8%8F%9C%E5%8D%95/07%402x%284%29.png',
					activeIcon: '', // TODO: 待替换选中态图标
					toRoute: 'OriginCenter',
				}, {
					index: 2,
					name: '生产加工端',
					icon: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%BA%95%E9%83%A8%E8%8F%9C%E5%8D%95/07%402x%20%283%29.png',
					activeIcon: '', // TODO: 待替换选中态图标
					url: 'https://sy.18yimu.com/',
					gap: '0 80px',
				}, {
					index: 3,
					name: '现代服务端',
					icon: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%BA%95%E9%83%A8%E8%8F%9C%E5%8D%95/07%402x%20%284%29.png',
					activeIcon: '', // TODO: 待替换选中态图标
					toRoute: 'TalentService',
				}, {
					index: 4,
					name: '供需市场端',
					icon: 'https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E5%BA%95%E9%83%A8%E8%8F%9C%E5%8D%95/07%402x%20%285%29.png',
					activeIcon: '', // TODO: 待替换选中态图标
					url: 'https://www.huoguogo.cn/',
					gap: '0 0 0 80px',
				}],
			}
		},
		created() {
			this.syncTabbar()
		},
		watch: {
			'$route.path'() {
				this.syncTabbar()
			}
		},
		methods: {
			onMenuClick(i) {
				const m = this.menuList[i]
				// 外跳项：仅打开新窗口，不高亮
				if (m.url) {
					this.openUrl(m.url)
					return
				}
				// 内跳项：文案高亮后路由到独立页面
				this.menuIndex = m.index
				if (this.$route.name !== m.toRoute) {
					this.$router.push({
						name: m.toRoute,
						query: this.$route.query
					})
				}
			},
			syncTabbar() {
				if (this.$route.name === 'AbilityCenter') {
					this.tabbarIndex = 2
				} else if (this.$route.name === 'ComponentOverview') {
					this.tabbarIndex = 2
				} else if (this.$route.name === 'IndustryWarehouse') {
					this.tabbarIndex = 7
				} else if (this.$route.name === 'NationalMap') {
					this.tabbarIndex = 3
				} else if (this.$route.name === 'IndustryChainMap') {
					this.tabbarIndex = 5
				} else if (this.$route.name === 'IndustryChainMapV2') {
					this.tabbarIndex = 6
				} else {
					this.tabbarIndex = 1
				}
			},
			goDataCenter() {
				this.tabbarIndex = 1
				if (this.$route.name !== 'HomeView') {
					this.$router.push({
						name: 'HomeView',
						query: this.$route.query
					})
				}
			},
			goAbilityCenter() {
				this.tabbarIndex = 2
				if (this.$route.name !== 'AbilityCenter') {
					this.$router.push({
						name: 'AbilityCenter',
						query: this.$route.query
					})
				}
			},
			goIndustryWarehouse() {
				this.tabbarIndex = 7
				if (this.$route.name !== 'IndustryWarehouse') {
					this.$router.push({
						name: 'IndustryWarehouse',
						query: this.$route.query
					})
				}
			},
			goNationalMap() {
				this.tabbarIndex = 3
				if (this.$route.name !== 'NationalMap') {
					this.$router.push({
						name: 'NationalMap',
						query: this.$route.query
					})
				}
			},
			goIndustryChain() {
				this.tabbarIndex = 5
				if (this.$route.name !== 'IndustryChainMap') {
					this.$router.push({
						name: 'IndustryChainMap',
						query: this.$route.query
					})
				}
			},
			goIndustryChainV2() {
				this.tabbarIndex = 6
				if (this.$route.name !== 'IndustryChainMapV2') {
					this.$router.push({
						name: 'IndustryChainMapV2',
						query: this.$route.query
					})
				}
			},
			openUrl(url) {
				window.open(url)
			},
          goCenterAdmin(){
            window.open('https://merchant.huoguogo.cn')
          },
			openHg() {
				window.open('https://www.huoguogo.cn/')
			},
			back() {
				this.$router.go(-1)
			},
			goOld() {
				this.$router.push({
					path: '/viewsO',
					query: {
						accessToken: this.$route.query.accessToken
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.tabbar-default {
		width: 135px;
		height: 37px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A1%B6%E9%83%A8%E6%A0%87%E9%A2%98%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
		background-size: 100% 100%;

		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 400;
		font-size: 18px;
		color: #DAEDFF;
		text-align: center;
		line-height: 37px;
		cursor: pointer;
	}

	.tabbar-check {
		width: 135px;
		height: 37px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A1%B6%E9%83%A8%E6%A0%87%E9%A2%98%E9%80%89%E4%B8%AD%402x.png');
		background-size: 100% 100%;

		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 400;
		font-size: 18px;
		color: #DAEDFF;
		text-align: center;
		line-height: 37px;
		cursor: pointer;
	}

	.tabbar-default2 {
		width: 135px;
		height: 37px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A1%B6%E9%83%A8%E5%8F%B3%E6%A0%87%E9%A2%98%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png');
		background-size: 100% 100%;

		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 400;
		font-size: 18px;
		color: #DAEDFF;
		text-align: center;
		line-height: 37px;
		cursor: pointer;
	}

	.tabbar-check2 {
		width: 135px;
		height: 37px;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A1%B6%E9%83%A8%E5%8F%B3%E6%A0%87%E9%A2%98%E9%80%89%E4%B8%AD%402x.png');
		background-size: 100% 100%;

		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 400;
		font-size: 18px;
		color: #DAEDFF;
		text-align: center;
		line-height: 37px;
		cursor: pointer;
	}

	.back-ability {
		display: inline-block;
		height: 32px;
		padding: 0 16px;
		font-size: 14px;
		color: #00e5ff;
		line-height: 32px;
		cursor: pointer;
		background: rgba(0, 180, 255, 0.12);
		border: 1px solid rgba(0, 212, 255, 0.6);
		border-radius: 4px;
		transition: all .2s;

		&:hover {
			background: rgba(0, 180, 255, 0.24);
			box-shadow: 0 0 10px rgba(0, 180, 255, 0.35);
			color: #fff;
		}
	}

	.topinfo {
		position: fixed;
		top: 10px;
		width: 100%;
		z-index: 99;
		flex-direction: column;
		align-items: flex-start;
		/* 顶栏容器与 .top-title 同为 z-index 99 且排在其后，整行透明覆盖在标题上并吃掉点击。
		   不能直接抬 .top-title 层级（其 100vw 底图会反过来遮住 tab），
		   改为容器不接受点击、仅内部可交互元素恢复点击，空白处自然穿透到标题 */
		pointer-events: none;
	}

	.topinfo .tabbar-default,
	.topinfo .tabbar-check,
	.topinfo .tabbar-default2,
	.topinfo .tabbar-check2,
	.topinfo .back-ability,
	.topinfo img {
		pointer-events: auto;
	}

	.topinfo-main {
		width: 100%;
	}

	.back-ability-row {
		padding: 0 0 6px 10px;
        margin:20px 0 0 0;
	}

	.bottom-menu {
		position: fixed;
		bottom: 2%;
		left: 0;
		width: 40%;
		margin-left: 30%;
		z-index: 7;
		cursor: pointer;

		.menu-title-noCheck {
			font-family: YouSheBiaoTiHei;
			font-size: 20px;
			color: #FFFFFF;
			letter-spacing: 1px;
			opacity: 0.6;
		}

		.menu-title {
			font-family: YouSheBiaoTiHei;
			font-size: 20px;
			color: #FFFFFF;
			letter-spacing: 1px;
		}

		.menu-image {
			width: 110px;
			height: 110px;
		}
	}

	.cont {
		position: fixed;
		width: 100%;
		height: 100%;
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E8%83%8C%E6%99%AF%402x.png');
		background-size: 100% 100%;
		// background: #001b39;
	}

	.top-title {
		background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%A1%B6%E9%83%A8%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png');
		background-size: 100% 90%;
		background-repeat: no-repeat;
		position: fixed;
		background-position: center;
		top: 0;
		left: 0;
		width: 100vw;
		height: 102px;
		z-index: 99;
		text-align: center;
		cursor: pointer;
		font-family: TBMCYXT, TBMCYXT;
		font-weight: 900;
		font-size: 38px;
		color: #FFFFFF;
		letter-spacing: 10px;
		text-stroke: 0px #FFFFFF;
		text-align: center;
		font-style: normal;
		text-transform: none;
		-webkit-text-stroke: 0px #FFFFFF;
	}

</style>
